import { BusinessTypes, TimezoneData } from "@/types";
import Vue from "vue";
import { MutationTree } from "vuex";
import { GlobalState } from "@/types/store/clientzone/global";

export const mutations: MutationTree<GlobalState> = {
  SET_BUSINESS_TYPES: (state, payload: Array<BusinessTypes>): Array<BusinessTypes> => Vue.set(state, "businessTypes", payload),
  SET_TIMEZONES: (state, payload: Array<TimezoneData>): Array<TimezoneData> => Vue.set(state, "timezones", payload)
}
